import React, { Component } from 'react'
import { connect } from 'react-redux'

export class PaymentDetail extends Component {
    render() {
        const { detail } = this.props;
        return (
            <div>
                <table className="table table-sm t-tablo text-left">
                    <tbody>
                        <tr>
                            <th scope="row">Durumu :</th>
                            <td>{detail.statusMessage}</td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <th scope="row">Tolam Tutar :</th>*/}
                        {/*    <td>{detail.totalAmount} ₺</td>*/}
                        {/*</tr>*/}
                        <tr>
                            <th scope="row">Org.Ücreti Talimat Tutarı :</th>
                            <td>{detail.installmentAmount} ₺</td>
                        </tr>
                        {detail.isPayforPayment == 2 ? (
                            <tr>
                                <th scope="row">Ödenen Toplam Tutar :</th>
                                <td>{detail.totalAmount} ₺</td>
                            </tr>
                        ) : <span></span>
                        }
                        {detail.isPayforPayment == 2 ? (
                            <tr>
                                <th scope="row">Taksit Sayısı :</th>
                                <td>{detail.installmentCount}</td>
                            </tr>
                        ) : <span></span>
                        }
                        <tr>
                            <th scope="row">Başarılı Ödeme Sayısı :</th>
                            <td>{detail.successPaymentCount}</td>
                        </tr>
                        <tr>
                            <th scope="row">Başarısız Ödeme Sayısı :</th>
                            <td>{detail.failPaymentCount}</td>
                        </tr>
                        <tr>
                            <th scope="row">Beklenen Ödeme Sayısı :</th>
                            <td>{detail.waitingPaymentCount}</td>
                        </tr>
                        <tr>
                            <th scope="row">İşlemi Gerçekleştiren :</th>
                            <td>{detail.createUser}</td>
                        </tr>
                        <tr>
                            <th scope="row">Kart Adı :</th>
                            <td>{detail.cardHolderName}</td>
                        </tr>
                        <tr>
                            <th scope="row">Kredi Kartı Numarası :</th>
                            <td>{detail.creditCardNumber}</td>
                        </tr>
                        {/* <tr>
                            <td colspan="2">
                                Ödeme tarihinizden dolayı kazanma tarihi ile planlanan teslim tarihiniz farklılık gösterebilir.
                                Detaylar için lütfen temsilciniz ile iletişime geçiniz.
                                </td>
                        </tr> */}
                    </tbody>
                </table>

            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetail)